import axios from "axios";

//API BACK
export const URI = process.env.REACT_APP_API+'/rosmo/';

//URL IMG
export const URIMG = process.env.REACT_APP_API+'/images/';
//export const URIMB = process.env.REACT_APP_IMB;

export const TEST = process.env.REACT_APP_API+'/test/';

export function getToken (){
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    if(usuario === null){
        return  null
    }else{
        return usuario[0].token
    }
}

export function getRol (){
    const user = JSON.parse(sessionStorage.getItem('user'))
    if(user === null){
        return null
    }else{
        return user[0].rol
    }
}

export async function getPermission (usuario,modulo){
    try {
        const res = await axios.get(URI+'checkPermissions/'+usuario+'/'+modulo,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
        });
        if(res.status === 210){
            return res.status;
        }else{
            return res.data.asignar;
        }
    } catch (error) {
        return error.response.status
    }
}
